/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerAddressBrandRegionalManagerApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerAddressBrandRegionalManager: builder.query({
            query: ({ addressBrandId, pageNumber = 1, pageSize = 10 }) => ({
                url: 'v1/dealeraddressbrandregionalmanager/getlist',
                method: 'POST',
                body: {
                    addressBrandId,
                    pageNumber,
                    pageSize
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    return {
                        items: response.data.items,
                        count: response.data.totalCount || 0
                    };
                }
                return { items: [], count: 0 };
            },
            providesTags: ['DealerAddressBrandRegionalManager']
        }),

        getByIdDealerAddressBrandRegionalManager: builder.query({
            query: (id) => ({
                url: 'v1/dealeraddressbrandregionalmanager/getbyid',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return response.data;
                }
                return {};
            },
            providesTags: (result, error, id) => [{ type: 'DealerAddressBrandRegionalManager', id }]
        }),

        createDealerAddressBrandRegionalManager: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandregionalmanager/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandRegionalManager', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        updateDealerAddressBrandRegionalManager: builder.mutation({
            query: (data) => ({
                url: 'v1/dealeraddressbrandregionalmanager/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandRegionalManager', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        }),

        deleteDealerAddressBrandRegionalManager: builder.mutation({
            // Hem sayısal id hem { id, dealerAddressBrandId } kabul edilir (id request'e gider,
            // dealerAddressBrandId yalnızca hedefli cache invalidation için kullanılır).
            query: (arg) => {
                const id = arg && typeof arg === 'object' ? arg.id : arg;
                return {
                    url: 'v1/dealeraddressbrandregionalmanager/delete',
                    method: 'DELETE',
                    params: { id }
                };
            },
            invalidatesTags: (result, error, arg) => ['DealerAddressBrandRegionalManager', { type: 'DealerRegistration', id: arg?.dealerAddressBrandId }]
        })
    })
});

export const {
    useGetAllDealerAddressBrandRegionalManagerQuery,
    useGetByIdDealerAddressBrandRegionalManagerQuery,
    useCreateDealerAddressBrandRegionalManagerMutation,
    useUpdateDealerAddressBrandRegionalManagerMutation,
    useDeleteDealerAddressBrandRegionalManagerMutation
} = dealerAddressBrandRegionalManagerApi;
